module.exports = __webpack_public_path__ + "static/media/ppidemo.af3828b5.PNG";